import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tipoConta", "vezesCartao", "campoBoleto", "dataPagamento"]

  connect() {
    // Set initial visibility based on current especie value
    const especieInput = this.element.querySelector("[name='pagamento[especie]']") ||
                         this.element.querySelector("#pagamento_especie")
    if (especieInput) {
      this.#atualizarEspecie(especieInput.value)
    }
  }

  especieChanged(event) {
    this.#atualizarEspecie(event.detail?.value ?? event.target?.value ?? "")
  }

  buscaTipoAcao(event) {
    const contrato = event.detail?.value ?? event.target?.value ?? ""
    if (!contrato) return

    fetch(`/busca_tipo_previdencia?selected_contrato=${encodeURIComponent(contrato)}`, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html))
  }

  grupoChanged(event) {
    const grupoId = event.detail?.value ?? event.target?.value ?? ""

    fetch(`/filtro_subgrupos_por_grupo_pagamento?selected_grupo=${encodeURIComponent(grupoId)}`, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html))
  }

  calculaIgpm() {
    clearTimeout(this._igpmTimer)
    this._igpmTimer = setTimeout(() => this.#fetchIgpm(), 600)
  }

  // private

  #atualizarEspecie(valor) {
    const ehBoleto = valor === "Boleto"
    const ehConta = valor === "Creditado na Conta"
    const ehCartao = valor === "Cartão de Crédito"

    if (this.hasTipoContaTarget) {
      this.tipoContaTarget.classList.toggle("hidden", !ehConta)
    }
    if (this.hasVezesCartaoTarget) {
      this.vezesCartaoTarget.classList.toggle("hidden", !ehCartao)
    }
    this.campoBoletoTargets.forEach(el => {
      el.classList.toggle("hidden", !ehBoleto)
    })
  }

  #fetchIgpm() {
    const form = this.element
    const dataPagamento = form.querySelector("[name='pagamento[data_pagamento]']")?.value
    const dataVencimento = form.querySelector("[name='pagamento[data_vencimento]']")?.value
    const valorParcela = form.querySelector("[name='pagamento[valor_parcela]']")?.value
    const escritorioPaga = form.querySelector("[name='pagamento[escritorio_paga]']")?.checked

    if (!dataPagamento || !dataVencimento || !valorParcela) return

    const params = new URLSearchParams({
      data_pagamento: dataPagamento,
      data_vencimento: dataVencimento,
      valor_parcela: valorParcela,
      escritorio_paga: escritorioPaga ? "1" : "0"
    })

    fetch(`/calcula_igpm?${params}`, {
      headers: { Accept: "text/vnd.turbo-stream.html" }
    })
      .then(r => r.text())
      .then(html => Turbo.renderStreamMessage(html))
  }
}
